import {
  UsersMutations as Mutations,
  UsersStates as States,
  UsersGetters as Getters,
  UserActions as Actions
} from '../Storetypes'

import { db } from "../../firebase";
import firebase from "firebase";
import router from "../../router/index";
//import { GuestGuiderId } from '../../enums/Guider'
import { ToastProgrammatic as toast } from 'buefy';
import { BgColors } from './../../enums/BgColors';
import { authErrorMessage } from "../../utils/authErrors";
import { sendVerificationEmail, authHeaders } from "../../services/authApi";

// After signing in: back to the page the person was trying to open
// (?redirect=/admin/... added by the router), otherwise their dashboard
const goToRoute = (routeName) => {
  const redirect = router.currentRoute.query.redirect;
  const target = typeof redirect === "string" && redirect.startsWith("/") && !redirect.startsWith("//")
    ? redirect
    : { name: routeName };
  router.push(target).catch((err) => {
    console.log(err);
  });
}

// Sends the person to their dashboard only once (profile listeners fire
// again on every later change, e.g. saving settings)
const navigateOnce = () => {
  let done = false;
  return (routeName) => {
    if (done) return;
    done = true;
    goToRoute(routeName);
  };
};

// A Guiders profile was found: put it in the store with its role and go to
// the right dashboard. Returns false if the account is deactivated.
const applyAccount = ({ commit }, { table, userData, goOnce }) => {
  if (userData.isAccountInactive) {
    commit(Mutations.SET_IS_LOADING, false)
    commit(Mutations.SET_AUTHENTICATION_ERROR, 'Your account has been deactivated by your organization.')
    firebase.auth().signOut().catch(() => {})
    return false
  }
  commit(Mutations.SET_USER, userData)
  commit(Mutations.SET_IS_LOADING, false)
  if (table === "vendors") {
    commit(Mutations.SET_IS_VENDOR, true)
    goOnce('vendor-dashboard')
  } else if (table === "affiliates") {
    commit(Mutations.SET_IS_AFFILIATE, true)
    goOnce('affiliate-dashboard')
  } else if (table === "privateGuides") {
    commit(Mutations.SET_IS_PRIVATE_GUIDE, true)
    goOnce('guide-portal')
  } else if (userData.isAdmin) {
    commit(Mutations.SET_IS_ADMIN, true)
    goOnce('admin-dashboard')
  } else if (table === "guides" && userData.companyId) {
    commit(Mutations.SET_IS_EMPLOYEE, true)
    goOnce('guider-upcoming-activities')
  } else if (table === "guides") {
    commit(Mutations.SET_IS_COMPANY, true)
    goOnce('company-dashboard')
  }
  return true
}

const GOOGLE_INTENT_KEY = "guiders.googleIntent";

// Google account chosen: open the matching Guiders account, or create the
// profile when registering
const finishGoogleSignIn = async ({ commit, dispatch }, user, intent) => {
  commit(Mutations.SET_IS_LOADING, true)
  try {
    await dispatch(Actions.RESOLVE_ACCOUNT, user)
  } catch (error) {
    if (error.code === "guiders/no-account" && intent.mode === "register") {
      // Still signed in with Google: create the Guiders profile
      await dispatch(Actions.SIGN_UP_USER, { user, isGuider: intent.isGuider, companyId: intent.companyId })
      return
    }
    // Not a Guiders account: don't leave a half signed-in session
    await firebase.auth().signOut().catch(() => {})
    throw error
  }
}

const removeUserFromDB = ({ tableName, uid }) => {
  db.firestore()
    .collection(tableName)
    .doc(uid)
    .delete()

}
export default {
  state: {
    [States.USER]: {},
    [States.ONE_SIGNAL_PLAYER_ID]:null,
    [States.COOKIES_ACCEPTED]: false,
    [States.EMPLOYEES]: [],
    [States.AUTHENTICATION_ERROR]: null,
    [States.IS_USER_A_GUIDER]: false,
    [States.IS_GUEST_GUIDER]: false,
    [States.IS_EMPLOYEE]: false,
    [States.IS_ADMIN]: false,
    [States.IS_COMPANY]: false,
    [States.IS_VENDOR]: false,
    [States.IS_AFFILIATE]: false,
    [States.IS_PRIVATE_GUIDE]: false,
    [States.SELECTED_EMPLOYEE_DATA]: {},
    [States.VENDOR_DATA]: {},
    [States.PASSWORD_CHANGED]: false,
    [States.IS_LOADING]: null
  },
  mutations: {
    [Mutations.SET_USER](state, userData) {
      state[States.USER] = userData
    },
    [Mutations.SET_ONE_SIGNAL_PLAYER_ID](state, id) {
      state[States.ONE_SIGNAL_PLAYER_ID] = id
    },
    [Mutations.SET_COOKIES_ACCEPTED](state, hasAcceptedCookies) {
      state[States.COOKIES_ACCEPTED] = hasAcceptedCookies
    },
    [Mutations.SET_EMPLOYEES](state, employees) {
      state[States.EMPLOYEES] = employees
    },
    [Mutations.SET_IS_LOADING](state, password) {
      state[States.IS_LOADING] = password
    },
    [Mutations.SET_AUTHENTICATION_ERROR](state, error) {
      state[States.AUTHENTICATION_ERROR] = error
    },
    [Mutations.SET_PASSWORD_CHANGED](state, passwordChanged) {
      state[States.PASSWORD_CHANGED] = passwordChanged
    },
    [Mutations.SET_IS_USER_GUIDER](state, isUserAGuider) {
      state[States.IS_USER_A_GUIDER] = isUserAGuider
    },
    [Mutations.SET_IS_EMPLOYEE](state, isEmployee) {
      state[States.IS_EMPLOYEE] = isEmployee
    },
    [Mutations.SET_IS_COMPANY](state, isCompany) {
      state[States.IS_COMPANY] = isCompany
    },
    [Mutations.SET_IS_ADMIN](state, isAdmin) {
      state[States.IS_ADMIN] = isAdmin
    },
    [Mutations.SET_IS_VENDOR](state, isVendor) {
      state[States.IS_VENDOR] = isVendor
    },
    [Mutations.SET_IS_PRIVATE_GUIDE](state, value) {
      state[States.IS_PRIVATE_GUIDE] = value
    },
    [Mutations.SET_IS_AFFILIATE](state, value) {
      state[States.IS_AFFILIATE] = value
    },
    
    [Mutations.SET_IS_GUEST_GUIDER](state, isGuestGuider) {
      state[States.IS_GUEST_GUIDER] = isGuestGuider
    },
    [Mutations.UPDATE_EMPLOYEE_DATA](state, updatedData) {
      state[States.USER].employees = updatedData
    },
  },
  actions: {
   /*  async [Actions.SIGN_UP]({ commit, dispatch }, payload) {
      await db
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then((user) => {
          var currentUser = db.auth().currentUser;
          const bgColor = BgColors[Math.floor(Math.random() * BgColors.length)]

          if (currentUser) {
            currentUser
              .updateProfile({
                displayName: payload.displayName,
                photoURL: `https://api.dicebear.com/5.x/initials/svg?seed=${payload.displayName}?backgroundColor=${bgColor}`,
              })
              .then(() => {
                dispatch(Actions.RESET_STATES)
                dispatch(Actions.SIGN_UP_USER, { user: user.user, isGuider: payload.isGuider })
              });
          }
        })
        .catch((error) => {
          const message = authErrorMessage(error)
          toast.open({
            duration: 10000,
            message,
            position: "is-bottom",
            type: "is-danger",
          });
          commit(Mutations.SET_IS_LOADING, false);
          commit(Mutations.SET_AUTHENTICATION_ERROR, message);
        });
    }, */
    // Email + password. The tab picked on the login page (Reseller / Guide or
    // team) says where the account lives.
    async [Actions.SIGN_IN]({ commit, dispatch }, payload) {
      const { isGuider, email, password, isVendor } = payload
      commit(Mutations.SET_AUTHENTICATION_ERROR, null)
      commit(Mutations.SET_IS_LOADING, true)

      let credential
      try {
        credential = await db.auth().signInWithEmailAndPassword(email, password)
      } catch (error) {
        commit(Mutations.SET_IS_LOADING, false)
        commit(Mutations.SET_AUTHENTICATION_ERROR, authErrorMessage(error))
        return
      }

      const tableName = isVendor ? "vendors" : isGuider ? "guides" : "users"
      dispatch(Actions.RESET_STATES)
      const goOnce = navigateOnce()
      let isFirstSnapshot = true

      // Live: later changes to the profile keep the store up to date
      db.firestore()
        .collection(tableName)
        .where("uid", "==", credential.user.uid).onSnapshot(docSnapshot => {
          const first = isFirstSnapshot
          isFirstSnapshot = false
          if (docSnapshot.empty) {
            if (!first) return
            // Right password, wrong tab (or no Guiders profile yet)
            commit(Mutations.SET_IS_LOADING, false)
            commit(Mutations.SET_AUTHENTICATION_ERROR, isVendor
              ? "We couldn't find a reseller account for this email. If you're a guide or part of the Guiders team, choose \"Guide or team\" above."
              : "We couldn't find a guide or team account for this email. If you sell passes, choose \"Reseller\" above.")
            firebase.auth().signOut().catch(() => {})
            return
          }
          docSnapshot.docs.forEach((doc) => {
            applyAccount({ commit, dispatch }, { table: tableName, userData: doc.data(), goOnce })
          })
        }, err => {
          console.log(`Encountered error: ${err}`);
          commit(Mutations.SET_IS_LOADING, false)
          commit(Mutations.SET_AUTHENTICATION_ERROR, authErrorMessage(err))
        });
    },

    // Google / email link: there's no tab, so look for the account in each
    // place it can live. Throws { code: "guiders/no-account" } if none (the
    // caller decides whether to sign out or create the profile).
    // Pass { user, tables } to only look in some places (e.g. the guide
    // portal only accepts private guide profiles).
    async [Actions.RESOLVE_ACCOUNT]({ commit, dispatch }, payload) {
      commit(Mutations.SET_AUTHENTICATION_ERROR, null)
      const firebaseUser = payload.user || payload
      const tables = payload.tables || ["vendors", "guides", "affiliates", "privateGuides"]
      const uid = firebaseUser.uid
      const store = db.firestore()
      for (const table of tables) {
        const snapshot = await store.collection(table).where("uid", "==", uid).limit(1).get()
        if (!snapshot.empty) {
          dispatch(Actions.RESET_STATES)
          const ok = applyAccount({ commit, dispatch }, { table, userData: snapshot.docs[0].data(), goOnce: navigateOnce() })
          if (!ok) throw Object.assign(new Error("inactive"), { code: "guiders/inactive" })
          return table
        }
      }
      throw Object.assign(new Error("no account"), { code: "guiders/no-account" })
    },
    async [Actions.SIGN_UP]({ commit, dispatch }, payload) {
      commit(Mutations.SET_AUTHENTICATION_ERROR, null)
      commit(Mutations.SET_IS_LOADING, true)
      try {
        const credential = await db.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        dispatch(Actions.RESET_STATES)
        const bgColor = BgColors[Math.floor(Math.random() * BgColors.length)]
        await credential.user.updateProfile({
          displayName: payload.displayName,
          photoURL: `https://api.dicebear.com/5.x/initials/svg?seed=${payload.displayName}?backgroundColor=${bgColor}`,
        })
        // Branded "confirm your email" (falls back to Firebase's own email)
        sendVerificationEmail().catch((error) => console.log("verification email", error))
        await dispatch(Actions.SIGN_UP_USER, { user: credential.user, isGuider: payload.isGuider, companyId: payload.companyId })
      } catch (error) {
        commit(Mutations.SET_IS_LOADING, false)
        commit(Mutations.SET_AUTHENTICATION_ERROR, authErrorMessage(error))
      }
    },

    async [Actions.RETRIEVE_USER_DATA]({ commit }, { uid, userData }) {
      if (userData.isAccountInactive) return
      let isGuider = false
      await db.firestore()
        .collection("guides")
        .where("uid", "==", uid).onSnapshot(docSnapshot => {

          docSnapshot.docChanges().forEach((change) => {
            isGuider = true
            commit(Mutations.SET_USER, change.doc.data())
          });
          if (isGuider) return
          commit(Mutations.SET_USER, userData)
        }, err => {
          console.log(`Encountered error: ${err}`);
        });
    },

    /* 
        async [Actions.SIGN_IN_WITH_LINK]({ commit }, payload) {
          await db
            .auth()
            .catch((error) => {
              toast.open({
                duration: 10000,
                message: error.message,
                position: "is-bottom",
                type: "is-danger",
              });
              commit(Mutations.SET_AUTHENTICATION_ERROR, error.message);
            });
        }, */
    async [Actions.SIGN_UP_WITH_LINK]({ commit }, email) {
      const actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for this
        // URL must be in the authorized domains list in the Firebase Console.
        url: 'https://guiders.pt',
        // This must be true.
        handleCodeInApp: true
      };

      await firebase
        .auth().sendSignInLinkToEmail(email, actionCodeSettings).then(() => {
          // notify and go back to dashboard
        })
        .catch((error) => {
          const message = authErrorMessage(error)
          toast.open({
            duration: 10000,
            message,
            position: "is-bottom",
            type: "is-danger",
          });
          commit(Mutations.SET_IS_LOADING, false);
          commit(Mutations.SET_AUTHENTICATION_ERROR, message);
        });
    },
    // Google sign-in.
    //  - { mode: "login" }: only for people who already have a Guiders account
    //  - { mode: "register", isGuider, companyId }: creates the profile if
    //    it doesn't exist yet (after the registration code / invitation)
    async [Actions.SIGN_IN_WITH_GOOGLE]({ commit, dispatch }, intent = { mode: "login" }) {
      commit(Mutations.SET_AUTHENTICATION_ERROR, null)
      const provider = new firebase.auth.GoogleAuthProvider()
      provider.setCustomParameters({ prompt: "select_account" })
      try {
        const result = await firebase.auth().signInWithPopup(provider)
        await finishGoogleSignIn({ commit, dispatch }, result.user, intent)
      } catch (error) {
        if (error.code === "auth/popup-blocked") {
          // Some phones block pop-ups: continue in the same tab instead
          try {
            window.sessionStorage.setItem(GOOGLE_INTENT_KEY, JSON.stringify(intent))
          } catch (e) {
            // storage blocked: login intent is the default
          }
          return firebase.auth().signInWithRedirect(provider)
        }
        commit(Mutations.SET_IS_LOADING, false)
        commit(Mutations.SET_AUTHENTICATION_ERROR, error.code === "guiders/no-account"
          ? "There's no Guiders account for this Google account yet. Log in with your email and password, or ask us for an invitation."
          : authErrorMessage(error))
      }
    },
    // Back from the Google redirect (login and registration pages call this)
    async [Actions.COMPLETE_GOOGLE_REDIRECT]({ commit, dispatch }) {
      let intent = { mode: "login" }
      try {
        intent = JSON.parse(window.sessionStorage.getItem(GOOGLE_INTENT_KEY)) || intent
        window.sessionStorage.removeItem(GOOGLE_INTENT_KEY)
      } catch (e) {
        // default intent
      }
      try {
        const result = await firebase.auth().getRedirectResult()
        if (!result || !result.user) return
        commit(Mutations.SET_IS_LOADING, true)
        await finishGoogleSignIn({ commit, dispatch }, result.user, intent)
      } catch (error) {
        commit(Mutations.SET_IS_LOADING, false)
        commit(Mutations.SET_AUTHENTICATION_ERROR, error.code === "guiders/no-account"
          ? "There's no Guiders account for this Google account yet. Log in with your email and password, or ask us for an invitation."
          : authErrorMessage(error))
      }
    },
    [Actions.SIGN_OUT]({ commit, dispatch }) {
      // Clear this device right away, so signing out works even if the
      // request to Firebase fails (offline, expired session...)
      dispatch(Actions.RESET_STATES)
      firebase.auth()
        .signOut()
        .then(() => {
          toast.open({
            duration: 10000,
            message: 'You have been signed out!',
            position: "is-bottom",
          });
          if (router.currentRoute.name !== "home") {
            router
              .push({
                path: "/",
              })
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((error) => {
          const message = authErrorMessage(error)
          toast.open({
            duration: 10000,
            message,
            position: "is-bottom",
            type: "is-danger",
          });
          commit(Mutations.SET_IS_LOADING, false);
          commit(Mutations.SET_AUTHENTICATION_ERROR, message);
        });
    },
    [Actions.RESET_STATES]({ commit }) {
      console.log('reset called');
      commit(Mutations.SET_USER, {});
      commit(Mutations.SET_EMPLOYEES, []);
      commit(Mutations.SET_IS_ADMIN, false);
      commit(Mutations.SET_IS_VENDOR, false);
      commit(Mutations.SET_IS_AFFILIATE, false);
      commit(Mutations.SET_IS_PRIVATE_GUIDE, false);
      commit(Mutations.SET_IS_GUEST_GUIDER, false);
      commit(Mutations.SET_IS_USER_GUIDER, false);
      commit(Mutations.SET_IS_EMPLOYEE, false);
      commit(Mutations.SET_IS_COMPANY, false);
      commit(Mutations.SET_AUTHENTICATION_ERROR, null);
      commit(Mutations.SET_PASSWORD_CHANGED, false);
      commit(Mutations.SET_IS_LOADING, false);
    },
    [Actions.AUTHENTICATE_USER]({ commit, dispatch }) {
      db.auth().onAuthStateChanged((user) => {
        if (user) {
          const {
            displayName,
            photoURL,
            phoneNumber,
            uid,
            email
          } = user

          // TODO:check to see if we can reduce db calls and still watch for changes
          dispatch(Actions.RETRIEVE_USER_DATA, {
            uid,
            userData: {
              displayName,
              photoURL,
              phoneNumber,
              uid,
              email,
            }
          })

          return true;
        } else {
          commit(Mutations.SET_USER, null)
          return false;
        }
      });
    },
    async [Actions.CHANGE_PASSWORD]({ commit }, { currentPassword, newPassword }) {
      const fail = (message) => {
        toast.open({ duration: 10000, message, position: "is-bottom", type: "is-danger" });
        commit(Mutations.SET_PASSWORD_CHANGED, false)
      }
      const user = db.auth().currentUser;
      if (!user) return fail("For your security, please log in again and then retry.")
      // Google / email-link accounts have no password to change
      if (!user.providerData.some((p) => p.providerId === "password")) {
        return fail("You sign in with Google or an email link, so there's no password to change. To add one, use \"Forgot your password?\" on the login page.")
      }
      try {
        const cred = firebase.auth.EmailAuthProvider.credential(user.email, currentPassword);
        await user.reauthenticateWithCredential(cred)
      } catch (error) {
        const wrong = ["auth/wrong-password", "auth/invalid-credential", "auth/invalid-login-credentials"].includes(error.code)
        return fail(wrong ? "Your current password isn't right. Please try again." : authErrorMessage(error))
      }
      try {
        await user.updatePassword(newPassword)
        toast.open({
          duration: 10000,
          message: 'Password successfully changed.',
          position: "is-bottom",
          type: "is-success"
        });
        commit(Mutations.SET_PASSWORD_CHANGED, true)
      } catch (error) {
        fail(authErrorMessage(error))
      }
    },
    [Actions.DELETE_USER]({ commit, state }) {
      const user = db.auth().currentUser
      const isGuider = state[States.IS_USER_A_GUIDER]
      const tableName = isGuider ? 'guides' : 'users'
      const uid = state[States.USER].uid
      user.deleteUser(user).then(() => {

        // TODO: UNCOMMENT IF NEEDED

        /*  if (isGuider) {
            fetch(`${process.env.VUE_APP_API_URL}/stripe/account/delete`, {
             method: "POST",
             body:  state[States.USER].stripeAccountId,
             headers: {
                 "Content-Type": "application/json",
             },
             credentials: "same-origin",
         }) 
             .then((response) => response.json()).then((data) => {
                 if (data.deleted) console.log('stripe account deleted');
             })
             .catch((error) => {
               console.log('stripe NOT account deleted', error);
               toast.open({
                 duration: 10000,
                 message: error,
                 position: "is-bottom",
               });
             });
         } */
        removeUserFromDB({ tableName, uid })
        commit(Mutations.SET_USER, null)
        toast.open({
          duration: 10000,
          message: 'Your account has been deleted.',
          position: "is-bottom",
        });
      }).catch((error) => {
        toast.open({
          duration: 10000,
          message: error.message,
          position: "is-bottom",
          type: "is-danger",
        });
      });

    },
    async [Actions.SIGN_UP_USER]({ commit, dispatch }, { user, isGuider, companyId }) {
      const userId = user.uid
      let userData = {
        displayName: user.displayName || (user.user && user.user.displayName) || "",
        photoURL: user.photoURL || (user.user && user.user.photoURL) || "",
        email: user.email || (user.user && user.user.email),
        uid: userId
      };

      if (isGuider) {
        userData.hasFinishedSetUp = false
        commit(Mutations.SET_IS_USER_GUIDER, true);
      }
      if (!companyId && isGuider) {
        commit(Mutations.SET_IS_COMPANY, true);
        await dispatch(Actions.REGISTER_USER, { isGuider, userData, userId, companyId })
        return
      }
      userData.registrationFinished = true
      await dispatch(Actions.REGISTER_EMPLOYEE, { userData, companyId })
    },
    // Creates the Guiders profile through the backend (which checks the
    // login token, so people can only create their own profile)
    async [Actions.REGISTER_USER]({ commit }, { isGuider, userData }) {
      const tableName = isGuider ? "guides" : "users"
      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/users/signup`, {
          method: "POST",
          body: JSON.stringify({ userData, tableName }),
          headers: { "Content-Type": "application/json", ...(await authHeaders()) },
        })
        const data = await response.json().catch(() => ({}))
        if (!response.ok) throw new Error(data.message || "We couldn't create your account. Please try again.")
        commit(Mutations.SET_USER, data.message && data.message.uid ? data.message : userData)
      } catch (error) {
        commit(Mutations.SET_IS_COMPANY, false)
        commit(Mutations.SET_AUTHENTICATION_ERROR, error.message)
      } finally {
        commit(Mutations.SET_IS_LOADING, false)
      }
    },

    async [Actions.SIGN_UP_VENDOR]({ commit }, user) {
      console.log({ user });
      commit(Mutations.SET_IS_LOADING, true)
      await db
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        .then(() => {
          var currentUser = db.auth().currentUser;
          const bgColor = BgColors[Math.floor(Math.random() * BgColors.length)]

          if (currentUser) {
            currentUser
              .updateProfile({
                isAccountCreated: true,
                displayName: user.displayName,
                photoURL: `https://api.dicebear.com/5.x/initials/svg?seed=${user.displayName}?backgroundColor=${bgColor}`,
              })
              .then(async () => {

                commit(Mutations.SET_IS_VENDOR, true);

                const userData = {
                  ...user,
                  isAccountCreated: true,
                  uid: currentUser.uid,
                  photoURL: `https://api.dicebear.com/5.x/initials/svg?seed=${user.displayName}?backgroundColor=${bgColor}`,
                }

                delete userData.password;

                const docRef = db.firestore().collection("vendors").doc(user.id)
                await docRef.update(userData);
                const updatedDoc = await docRef.get();
                commit(Mutations.SET_USER, updatedDoc.data())
                commit(Mutations.SET_IS_LOADING, false)
                // Branded "confirm your email" (falls back to Firebase's own)
                sendVerificationEmail().catch(() => {})
                goToRoute('vendor-dashboard')
              });
          }
        })
        .catch((error) => {
          const message = authErrorMessage(error)
          toast.open({
            duration: 10000,
            message,
            position: "is-bottom",
            type: "is-danger",
          });
          commit(Mutations.SET_IS_LOADING, false);
          commit(Mutations.SET_AUTHENTICATION_ERROR, message);
        });
    },

    async [Actions.SIGN_UP_AFFILIATE]({ commit }, user) {
      console.log({ user });
      commit(Mutations.SET_IS_LOADING, true)
      await db
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        .then(() => {
          var currentUser = db.auth().currentUser;
          const bgColor = BgColors[Math.floor(Math.random() * BgColors.length)]

          if (currentUser) {
            currentUser
              .updateProfile({
                isStripeAccountSetup: false,
                displayName: user.displayName,
                photoURL: `https://api.dicebear.com/5.x/initials/svg?seed=${user.displayName}?backgroundColor=${bgColor}`,
              })
              .then(async () => {

                commit(Mutations.SET_IS_AFFILIATE, true);

                const userData = {
                  ...user,
                  isStripeAccountSetup: false,
                  uid: currentUser.uid,
                  photoURL: `https://api.dicebear.com/5.x/initials/svg?seed=${user.displayName}?backgroundColor=${bgColor}`,
                }

                delete userData.password;

                const docRef = db.firestore().collection("affiliates").doc(user.stripeAccountId)
                await docRef.set(userData);
                const updatedDoc = await docRef.get();
                commit(Mutations.SET_USER, updatedDoc.data())
                commit(Mutations.SET_IS_LOADING, false)
                // Branded "confirm your email" (falls back to Firebase's own)
                sendVerificationEmail().catch(() => {})
              });
          }
        })
        .catch((error) => {
          const message = authErrorMessage(error)
          toast.open({
            duration: 10000,
            message,
            position: "is-bottom",
            type: "is-danger",
          });
          commit(Mutations.SET_IS_LOADING, false);
          commit(Mutations.SET_AUTHENTICATION_ERROR, message);
        });
    },
    async [Actions.REGISTER_EMPLOYEE]({ commit }, { companyId, userData }) {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/users/register-employee`, {
          method: "POST",
          body: JSON.stringify({ companyId, employeeData: userData }),
          headers: { "Content-Type": "application/json", ...(await authHeaders()) },
        })
        const data = await response.json().catch(() => ({}))
        if (!response.ok) throw new Error(data.message || "We couldn't create your account. Please try again.")
        commit(Mutations.SET_IS_EMPLOYEE, true)
        commit(Mutations.SET_USER, data.message && data.message.uid ? data.message : userData)
        goToRoute('guider-upcoming-activities')
      } catch (error) {
        commit(Mutations.SET_AUTHENTICATION_ERROR, error.message)
      } finally {
        commit(Mutations.SET_IS_LOADING, false)
      }
    },
    // todo-  UPDATE??????
    [Actions.GET_EMPLOYEE_DATA]({ state }, employeeId) {
      if (!employeeId) return
      db.firestore()
        .collection("guides").doc(employeeId).get().then((doc) => {
          if (doc.data()) {
            state[States.SELECTED_EMPLOYEE_DATA] = doc.data()
          }
        })
    },
    [Actions.GET_VENDOR_DATA]({ state }, vendorId) {
      if (!vendorId) return
      db.firestore()
        .collection("vendors").doc(vendorId).get().then((doc) => {
          if (doc.data()) {
            state[States.VENDOR_DATA] = doc.data()
          }
        })
    },
    async [Actions.GET_COMPANY_EMPLOYEES]({ commit }, companyId) {
      if (!companyId) return
      let employees = [];
      db.firestore()
        .collection("guides").where('companyId', "==", companyId).onSnapshot((snapshotChange) => {
          snapshotChange.forEach((doc) => {
            employees.push(doc.data());
          });
        });
      commit(Mutations.SET_EMPLOYEES, employees)
    },
    async [Actions.REGISTER_AFFILIATE]({ commit }, { email, password, name }) {
      commit(Mutations.SET_IS_LOADING, true)
      try {
        const { user } = await db.auth().createUserWithEmailAndPassword(email, password); 
        // TODO: Create stripe account and update db
        await db.firestore().collection("affiliates").doc(user.uid).set({ name, email, createdAt: new Date() });
        commit(Mutations.SET_USER, user)
        //commit("SET_USER", user);
      } catch (error) {
        commit(Mutations.SET_AUTHENTICATION_ERROR, error.message);
      } finally {
        commit(Mutations.SET_IS_LOADING, false)
      }
    },

    async [Actions.LOGIN_AFFILIATE]({ commit }, { email, password }) {
      commit(Mutations.SET_IS_LOADING, true)
      try {
        const { user } = await db.auth().signInWithEmailAndPassword(email, password);
        //TODO: find user in db THEN SET USER
        commit(Mutations.SET_USER, user)
      } catch (error) {
        commit(Mutations.SET_AUTHENTICATION_ERROR, error.message);
      } finally {
        commit(Mutations.SET_IS_LOADING, false)
      }
    },
// TODO: REMOVE?
    /* async checkAuth({ commit }) {
      auth.onAuthStateChanged((user) => {
        commit("SET_USER", user || null);
      });
    }, */

  },
  getters: {
    [Getters.GET_USER](state) {
      return state[States.USER];
    },
    [Getters.GET_ONE_SIGNAL_PLAYER_ID](state) {
      return state[States.ONE_SIGNAL_PLAYER_ID];
    },
    [Getters.IS_USER_AUTHENTICATED](state) {
      return !!state[States.USER];
    },
    [Getters.GET_AUTHENTICATION_ERROR](state) {
      return state[States.AUTHENTICATION_ERROR];
    }
  }

}